import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventTyping } from 'entities/Typing'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export const useEventTyping = (conversationMessageStore: ConversationMessagesStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseEventTyping) => {
    conversationMessageStore.handleTypingEvent(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.ClientTyping, handler), [])
}
